import React, { useRef } from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import { buildShareText } from "../../utils/triviaArcade";
import { arcadeOutlinedButtonSx } from "../../utils/triviaResultsLayout";
import { buildVerifyUrl, paintShareCardFaces } from "../../utils/triviaShareCard";
import TriviaShareCardScene from "./TriviaShareCardScene";

const TriviaShareCard = ({
  mode,
  grade,
  correct,
  total,
  score,
  shareToken,
  sportLabel,
  username,
  tier,
}) => {
  const downloadCanvasRef = useRef(null);
  const verifyUrl = buildVerifyUrl(
    typeof window !== "undefined" ? window.location.origin : "",
    shareToken
  );
  const card = {
    grade,
    correct,
    total,
    score,
    mode,
    sportLabel,
    username,
    shareToken,
    tier,
  };

  const handleCopyText = async () => {
    const text = buildShareText({ mode, correct, total });
    await navigator.clipboard.writeText(text);
  };

  const handleCopyLink = async () => {
    await navigator.clipboard.writeText(
      verifyUrl || `${window.location.origin}/app/trivia`
    );
  };

  const handleDownload = async () => {
    if (!downloadCanvasRef.current) {
      const { front } = await paintShareCardFaces({ ...card, verifyUrl });
      downloadCanvasRef.current = front;
    }
    downloadCanvasRef.current.toBlob((blob) => {
      if (!blob) return;
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "statsfan-trivia.png";
      link.click();
      URL.revokeObjectURL(url);
    });
  };

  return (
    <Box sx={{ mt: 1, textAlign: "center" }}>
      <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
        Share your score
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Drag the card to flip it, then copy the link or download a 2x PNG.
      </Typography>
      <Box sx={{ mb: 2 }}>
        <TriviaShareCardScene
          card={card}
          width="min(320px, 88vw)"
          onFrontReady={(front) => {
            downloadCanvasRef.current = front;
          }}
        />
      </Box>
      <Stack
        role="toolbar"
        aria-label="Share score"
        direction="row"
        spacing={1}
        justifyContent="center"
        sx={{
          width: "100%",
          maxWidth: 420,
          mx: "auto",
          "& > *": { flex: "1 1 0", minWidth: 0 },
        }}
      >
        <Button variant="outlined" onClick={handleCopyText} sx={arcadeOutlinedButtonSx}>
          Copy text
        </Button>
        <Button variant="outlined" onClick={handleCopyLink} sx={arcadeOutlinedButtonSx}>
          Copy link
        </Button>
        <Button variant="outlined" onClick={handleDownload} sx={arcadeOutlinedButtonSx}>
          Download card
        </Button>
      </Stack>
    </Box>
  );
};

export default TriviaShareCard;
